import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService, CommonPortalUrlService, UrlParamService } from 'gast-portal-ng';
import { TranslationService, Product } from 'gast-common-ng';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private commonPortalUrlService: CommonPortalUrlService,
        private translationService: TranslationService,
        private router: Router,
        private route: ActivatedRoute,
        private urlParamService: UrlParamService,
    ) { }

    canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
        this.urlParamService.saveSessionFromParamAndRemoveParam(routeSnapshot.queryParamMap);

        return this.http.get(this.commonPortalUrlService.getUserInfo(), { withCredentials: true }).pipe(
            map((response: any) => {
                if (response && response.name) {
                    this.authService.saveUserObjectInStorage(response.name, response.principal.longusername);
                    return true;

                } else {
                    return this.handleNotLoggedIn();
                }
            }),
            catchError((err) => {
                console.log('failed to retrieve user-info', err);
                return of(false);
            })
        );
    }

    private handleNotLoggedIn() {
        this.authService.saveUserObjectInStorage(null, null);
        this.router.navigate(['/course'], {
            relativeTo: this.route,
            queryParams: { lang: this.translationService.getCurrentLanguageCode().toLocaleLowerCase() },
        });
        return false;
    }
}
